/* eslint-disable no-mixed-operators */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component, lazy, Suspense } from 'react';
import SelectView from './select-view';
import { LEFT_BAR_WIDTH } from '@editor/src/js/constants';
import { setSelectedWithRect } from '@editor/src/page/index/components/canvas/canvas-edit-logic';
import ColorPicker from '../../../../../../frame-pc/components/color-picker';
import ErrorBoundary from '../../../../../../frame/components/error-boundary';
import RenderServiceManager, { LayerType } from '@src/slide/content-viewer/service/canvas-renderer/entry/base/feature/render-service-manager';
import OperationRenderServiceManager from '@src/slide/content-viewer/service/canvas-renderer/entry/base/feature/operation-render-service-manager';
import DomCompatibleWrapper from './dom-compatible-wrapper';
import { reduceWHbyRatio } from '@src/slide/infrastructure/module/independent/graphic/resize';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { ServicesContext } from './edit-panel/context';
import { DOMId } from '@editor/src/page/index/components/canvas/canvas-constants';
import { IRenderRectConfig } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/edit-mobile/type';
import { reaction, IReactionDisposer } from 'mobx';
import EditorPasteSpecialPanel from '@src/framework/frame-pc/components/paste-special-panel/editor-paste-panel';
import TextPasteSpecialPanel from '@src/framework/frame-pc/components/paste-special-panel/text-paste-panel';
import AsyncBoundary from '@src/framework/frame/components/async-boundary';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { SLIDE_RENDER_ENTRY } from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';
import {
    IPcEditorAreaService,
    IPcEditorContentDependentServices,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/edit-pc/pc-content-service.interface';
import { ISlideComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/slide/types';
import { CommonColor } from '@editor/src/js/constants/common-color';

const EditPanelPc = lazy(() => import(/* webpackChunkName: "editPanel" */ './edit-panel/pc'));

const HORIZONTAL_OFFSET = LEFT_BAR_WIDTH; // 横向偏移，为了解决火狐光标位置不正确问题。

interface ISlideWrapperProps {
    canvasSize: any;
    getPageScale: () => number;
    mobileEditMode?: () => any;
    updateComponentWhenCanvasDidUpdate?: () => any;
}

export default class SlideWrapper extends Component<ISlideWrapperProps, any> {
    public static contextTypes = {
    };
    private slideRef: any;
    private backgroundLayerRef: HTMLDivElement | null;
    private masterLayerRef: HTMLDivElement | null;
    private layoutLayerRef: HTMLDivElement | null;
    private operationCanvasRef: HTMLCanvasElement | null;
    private overlayCanvasRef: HTMLCanvasElement | null;
    private tempCanvasRef: HTMLCanvasElement | null;
    private editorLayer: IPcEditorAreaService;
    private canvasRef: HTMLDivElement | null;
    private stableLayer: HTMLDivElement | null;
    private canvasLayerWrapperRef: HTMLDivElement | null;
    private currentScrollChange: IReactionDisposer;

    private transitionPreviewWrapperRef: HTMLDivElement | null;

    public constructor(props, context) {
        super(props, context);
        this.state = {
            slideList: this.getAppServices().viewableServiceLayer.selectionService.slides,
        };
        this.slideRef = {};
    }

    // eslint-disable-next-line complexity
    public componentDidMount(): void {
        const rect = document.getElementById(DOMId.CANVAS)!.getBoundingClientRect?.();
        if (this.canvasRef) {
            const services: IPcEditorContentDependentServices = {
                infrastructureService: this.getAppServices().getInfrastructureService(),
                uiDataService: this.getAppServices().getUiDataService(),
                selectionService: this.getAppServices().viewableServiceLayer.selectionService,
                animManager: this.getAppServices().viewableServiceLayer.animManager,
                slideListRenderState: this.getAppServices().viewableServiceLayer.slideRenderStateManager,
                masterLayoutEditService: this.getAppServices().editableServiceLayer?.masterLayoutEditService,
                editAreaCanvasSizeManager: this.getAppServices().viewableServiceLayer.editAreaCanvasSizeManager,
                pcScrollService: this.getAppServices().viewableServiceLayer.pcScrollService,
                mediaManager: this.getAppServices().viewableServiceLayer.mediaManager,
                addonManager: this.getAppServices().viewableServiceLayer.addonManager,
                formatBrushManager: this.getAppServices().editableServiceLayer?.formatBrushManager,
                editingStateManager: this.getAppServices().viewableServiceLayer.editingStateManager,
                attachmentManager: this.getAppServices().viewableServiceLayer.attachmentManager,
                rightSideBarManager: this.getAppServices().editableServiceLayer?.rightSideBarManager,
                exportImageManager: this.getAppServices().viewableServiceLayer.exportImageManager,
                editorInstanceService: this.getAppServices().viewableServiceLayer.editorInstanceService,
                getEditorAnimPreviewManager: this.getAppServices().viewableServiceLayer.getEditorAnimPreviewManager,
                previewService: this.getAppServices().editableServiceLayer?.previewService,
                textEditorStateService: this.getAppServices().viewableServiceLayer.textEditorStateService,
                historyManager: this.getAppServices().editableServiceLayer?.historyManager,
                copyPasteImageService: this.getAppServices().editableServiceLayer?.copyPasteImageService,
                fontManager: this.getAppServices().viewableServiceLayer.fontManager,
                linkManager: this.getAppServices().viewableServiceLayer.linkManager,
                accessibilityManager: this.getAppServices().viewableServiceLayer.accessibilityManager,
                undoRedoService: this.getAppServices().editableServiceLayer?.undoRedoService,
                textSelectionUndoRedo: this.getAppServices().editableServiceLayer?.textSelectionUndoRedo,
                listService: this.getAppServices().viewableServiceLayer.slideListService,
                gifService: this.getAppServices().viewableServiceLayer?.gifService,
            };

            this.editorLayer = this.getAppServices().viewableServiceLayer.contentRendererService;
            this.editorLayer.initService({
                editable: this.getAppServices().viewableServiceLayer.userPriviledgeService.isEditable(),
                canvasWrapper: this.canvasRef,
                scale: this.props.getPageScale(),
                stableLayerWrapper: this.stableLayer,
                updateStableLayerTranslate: this.updateStableLayerTranslate,
                viewportSize: rect,
                contentSize: this.props.canvasSize,
                services,
                onSlideWillRender: this.onSlideWillRender,
                onSlideDidRender: this.onSlideDidRender,
            });
        }
        const renderRectConfig: IRenderRectConfig = {
            contentSize: this.props.canvasSize,
            scrollLeft: 0,
            scrollTop: 0,
        };
        if (this.operationCanvasRef && this.overlayCanvasRef) {
            OperationRenderServiceManager.getInstance().initLayer({
                width: rect.width,
                height: rect.height,
                scale: this.props.getPageScale(),
                renderRectConfig,
            }, this.operationCanvasRef, this.overlayCanvasRef);
        }
        if (this.tempCanvasRef) {
            const renderServiceManager = RenderServiceManager.getInstance();
            const props = {
                width: rect.width,
                height: rect.height,
                scale: this.props.getPageScale(),
                renderRectConfig,
            };
            renderServiceManager.initLayer({ ...props, canvasElement: this.tempCanvasRef }, LayerType.TEMP);
            renderServiceManager.initLayer({ ...props, canvasElement: this.tempCanvasRef }, LayerType.GUIDE);
        }

        this.initTransitionPreviewLayer(rect, renderRectConfig);

        this.currentScrollChange = reaction(() => [
            this.getPcScrollService().currentScrollX,
            this.getPcScrollService().currentScrollY,
        ], () => this.handleCanvasWrapperScroll());
    }

    public componentWillUnmount() {
        if (this.canvasRef) {
            this.editorLayer.dispose();
        }
        OperationRenderServiceManager.getInstance().dispose();
        RenderServiceManager.getInstance().dispose();
        this.currentScrollChange?.();
    }

    public componentDidUpdate(prevProps: Readonly<ISlideWrapperProps>, prevState: Readonly<any>, snapshot?: any) {
        const rect = document.getElementById(DOMId.CANVAS)!.getBoundingClientRect?.();
        if (this.editorLayer) {
            this.editorLayer.updateWithData(
                this.props.getPageScale(),
                this.props.canvasSize,
                rect,
            );
        }
        const renderRectConfig: IRenderRectConfig = {
            contentSize: this.props.canvasSize,
            scrollLeft: 0,
            scrollTop: 0,
            currentScrollX: this.getPcScrollService().currentScrollX,
            currentScrollY: this.getPcScrollService().currentScrollY,
        };
        OperationRenderServiceManager.getInstance().updateWithData({
            width: rect.width,
            height: rect.height,
            scale: this.props.getPageScale(),
            renderRectConfig,
        });
        RenderServiceManager.getInstance().updateWithData({
            width: rect.width,
            height: rect.height,
            scale: this.props.getPageScale(),
            renderRectConfig,
        });

        this.updateTransitionPreviewLayer(rect, renderRectConfig);

        this.props.updateComponentWhenCanvasDidUpdate?.();
    }

    // eslint-disable-next-line complexity
    public render() {
        const { slideWidth, slideHeight } = this.getAppServices().getUiDataService().presentation.props;
        const {
            width, height, left, top, scale,
        } = this.props.canvasSize;
        const wrapLeft = Math.round(-((width + HORIZONTAL_OFFSET) / scale - (width + HORIZONTAL_OFFSET)) / 2);
        const wrapTop = Math.round(-(height / scale - height) / 2);
        const { newWidth: smallerSlideWidth, newHeight: smallerSlideHeight } = reduceWHbyRatio(
            slideWidth,
            slideHeight,
            0.2 / scale,
        );
        const chartManager = this.getAppServices().editableServiceLayer?.chartManager;
        const guidesManager = this.getAppServices().editableServiceLayer?.guidesManager;
        const gridLineManager = this.getAppServices().editableServiceLayer?.gridLineManager;
        const menuManager = this.getAppServices().editableServiceLayer?.menuManager;
        const masterLayoutEditService = this.getAppServices().editableServiceLayer?.masterLayoutEditService;
        const { selectionService } = this.getAppServices().viewableServiceLayer;
        const selectedElements = selectionService.selectedElements.selectedArray || [];

        // todo: 延后调用
        guidesManager?.setCanvasSize({
            slideWidth,
            slideHeight,
            scale,
            ...this.props.canvasSize,
        });
        const slideAreaSize = {
            width: slideWidth, // Hardcoded to 1100:850 aspect ratio
            height: slideHeight,
            top: Math.round(top / scale),
            left: Math.round(left / scale),
        };
        return (<SelectView
            selectedElements={selectedElements}
            selectedFinished={this.handleSelectedFinish.bind(this)}
            formatBrushManager={this.getAppServices().editableServiceLayer?.formatBrushManager}
            animBrushManager={this.getAppServices().editableServiceLayer?.animBrushManager}
        >
            { /* 1.把Scale放到中间全部区域，而不仅仅是slide。2.以中心scale和宽度加上HORIZONTAL_OFFSET是为了解决火狐的光标会偏移问题 */}
            {
                <div style={{
                    width: Math.round(width / scale),
                    height: Math.round(height / scale),
                    transformOrigin: 'left top',
                    transform: `scale(${scale})`,
                    position: 'absolute',
                }}>
                    <div style={{
                        position: 'absolute',
                        width: smallerSlideWidth,
                        height: smallerSlideHeight,
                        top: Math.round(top / scale),
                        left: Math.round(left / scale),
                        border: '0 solid rgba(0, 0, 0, 0.06)',
                        boxShadow: '0 7px 21px 0 rgba(0, 0, 0, 0.12)',
                    }}
                    >
                    </div>
                </div>
            }
            {
                <div
                    className="stable-layer-wrapper"
                    ref={((element) => {
                        this.stableLayer = element;
                    })}
                    style={{ position: 'absolute', left: 0, top: 0, pointerEvents: 'none' }}
                />
            }
            {
                <div
                    className="slide-wrapper-canvasRef"
                    ref={((element) => {
                        this.canvasRef = element;
                    })}
                    style={{ position: 'absolute', left: 0, top: 0 }}
                />
            }
            <div
                className="canvas-layer-wrapper"
                ref={((element) => {
                    this.canvasLayerWrapperRef = element;
                })}
                style={{ position: 'absolute', left: 0, top: 0 }}
            >
                {
                    // 编辑层
                    <canvas
                        className="edit-wrapper-canvasRef"
                        ref={((element) => {
                            this.operationCanvasRef = element;
                        })}
                        style={{ position: 'absolute', left: 0, top: 0, pointerEvents: 'none' }}
                    />
                }
                {
                    // 覆盖层
                    <canvas
                        className="overlay-wrapper-canvasRef"
                        ref={((element) => {
                            this.overlayCanvasRef = element;
                        })}
                        style={{ position: 'absolute', left: 0, top: 0, pointerEvents: 'none' }}
                    />
                }
                {
                    // 临时元素层
                    <canvas
                        className="temp-wrapper-canvasRef"
                        ref={((element) => {
                            this.tempCanvasRef = element;
                        })}
                        style={{ position: 'absolute', left: 0, top: 0, pointerEvents: 'none' }}
                    />
                }
            </div>
            {<DomCompatibleWrapper
                width={width}
                height={height}
                top={top}
                left={left}
                scale={scale}
                wrapLeft={wrapLeft}
                wrapTop={wrapTop}
                horizontalOffest={HORIZONTAL_OFFSET}
                getPageScale={this.props.getPageScale}
                mobileEditMode={this.props.mobileEditMode}
            />}
            {
                <div style={{
                    width: Math.round(width / scale),
                    height: Math.round(height / scale),
                    transformOrigin: 'left top',
                    transform: `scale(${scale})`,
                    position: 'absolute',
                    pointerEvents: 'none',
                }}>
                    <div id={'slide-area'}
                        style={{
                            position: 'absolute',
                            ...slideAreaSize,
                        }}
                    >
                        {
                            <ErrorBoundary>
                                <Suspense fallback={<div/>}>
                                    <ServicesContext.Provider
                                        value={{
                                            editingStateManager: this.getAppServices()
                                                .viewableServiceLayer.editingStateManager,
                                            cursorManager: this.getAppServices().viewableServiceLayer.cursorManager,
                                            editorAnimPreviewManager: this.getAppServices()
                                                .viewableServiceLayer.getEditorAnimPreviewManager(),
                                            snapLineService: this.getAppServices()
                                                .editableServiceLayer?.snapLineService,
                                        }}
                                    >
                                        <EditPanelPc
                                            scale={scale}
                                            slideAreaSize={slideAreaSize}
                                        />
                                    </ServicesContext.Provider>
                                </Suspense>
                            </ErrorBoundary>
                        }
                    </div>
                </div>
            }

            { /* 切页动画预览层 */}
            {
                <div
                    className="transition-preview-wrapper"
                    ref={((element) => {
                        this.transitionPreviewWrapperRef = element;
                    })}
                    style={{
                        position: 'absolute', left: 0, top: 0, pointerEvents: 'none',
                        zIndex: 99, backgroundColor: CommonColor.F2F2F2,
                    }}
                ></div>
            }

            { /* 协作光标的标签 */}
            <AsyncBoundary>
                {async () => this.getAppServices().viewableServiceLayer.cursorManager
                    .promise().then(cursorManager => cursorManager.renderCursorTags({
                        scale,
                        top,
                        left,
                    }))}
            </AsyncBoundary>

            {/* 选择性粘贴面板 */}
            <EditorPasteSpecialPanel
                canvasTop={this.props.canvasSize.top}
                canvasLeft = {this.props.canvasSize.left}
                scale = {this.props.canvasSize.scale}
                serviceDelegates={{
                    uiDataService: this.getAppServices().getUiDataService(),
                    selectionService: this.getAppServices().viewableServiceLayer.selectionService,
                    editingStateManager: this.getAppServices().viewableServiceLayer.editingStateManager,
                    masterLayoutEditService: this.getAppServices().editableServiceLayer?.masterLayoutEditService,
                    undoRedoService: this.getAppServices().editableServiceLayer?.undoRedoService,
                    copyPasteManager: this.getAppServices().editableServiceLayer?.copyPasteManager,
                }}
            />
            <TextPasteSpecialPanel
                scale={this.props.canvasSize.scale}
                services={{
                    uiDataService: this.getAppServices().getUiDataService(),
                    selectionService: this.getAppServices().viewableServiceLayer.selectionService,
                    undoRedoService: this.getAppServices().editableServiceLayer?.undoRedoService,
                    copyPasteManager: this.getAppServices().editableServiceLayer?.copyPasteManager,
                    editorInstanceService: this.getAppServices().viewableServiceLayer.editorInstanceService,
                    textSelectionUndoRedo: this.getAppServices().editableServiceLayer?.textSelectionUndoRedo,
                    textSelectivePasteState: this.getAppServices().editableServiceLayer?.textSelectivePasteState,
                    editingStateManager: this.getAppServices().viewableServiceLayer.editingStateManager,
                }}
            />
        </SelectView>);
    }

    public handleCanvasWrapperScroll = () => {
        const { currentScrollX, currentScrollY } = this.getPcScrollService();
        // 更新元素层位置
        this.editorLayer.updatePosition();
        if (this.canvasLayerWrapperRef) {
            // 更新操作层&覆盖层&临时层父元素偏移
            this.canvasLayerWrapperRef.style.transform = `translate(${-currentScrollX}px, ${-currentScrollY}px)`;
        }
        const renderRectConfig: IRenderRectConfig = {
            contentSize: this.props.canvasSize,
            scrollLeft: 0,
            scrollTop: 0,
            currentScrollX: this.getPcScrollService().currentScrollX,
            currentScrollY: this.getPcScrollService().currentScrollY,
        };
        // 更新操作层&覆盖层&临时层位置
        OperationRenderServiceManager.getInstance().updatePosition(renderRectConfig);
        RenderServiceManager.getInstance().updatePosition(renderRectConfig);

        const rect = document.getElementById(DOMId.CANVAS)!.getBoundingClientRect?.();
        this.updateTransitionPreviewLayer(rect, renderRectConfig);
    };

    private handleSelectedFinish(rect, offset) {
        if (ColorPicker.isShown()) return;
        setSelectedWithRect(
            this.getAppServices().viewableServiceLayer.selectionService,
            rect,
            this.props.getPageScale(),
            this.props.canvasSize,
            offset,
        );
    }

    private getAppServices(): IPcEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IPcEditorAppServices;
    }

    private updateStableLayerTranslate = (left: number, top: number) => {
        if (this.stableLayer) {
            this.stableLayer.style.transform = `translate(${left}px, ${top}px)`;
        }
    };

    private onSlideWillRender = (slideModel: ISlideModel) => {
        slideModel.pptEditorState = this.getAppServices()
            .viewableServiceLayer.userPriviledgeService.pptEditorState;
    };

    private onSlideDidRender = (slideComponent: ISlideComponent) => {
        this.getAppServices().viewableServiceLayer.slideRenderStateManager
            .setSlideRenderCompleted(slideComponent, SLIDE_RENDER_ENTRY.EDIT_PC);
    };

    private getPcScrollService() {
        return (this.getAppServices() as IPcEditorAppServices).viewableServiceLayer.pcScrollService;
    }

    private initTransitionPreviewLayer(rect: DOMRect, renderRectConfig: IRenderRectConfig) {
        if (this.transitionPreviewWrapperRef) {
            this.getAppServices().editableServiceLayer?.transitionService?.promise().then((module) => {
                module.initPreviewLayer({
                    width: rect.width,
                    height: rect.height,
                    scale: this.props.getPageScale(),
                    renderRectConfig,
                    ref: this.transitionPreviewWrapperRef!,
                });
            });
        }
    }

    private updateTransitionPreviewLayer(rect: DOMRect, renderRectConfig: IRenderRectConfig) {
        this.getAppServices().editableServiceLayer?.transitionService?.promise().then((module) => {
            module.updatePreviewLayer({
                width: rect.width,
                height: rect.height,
                scale: this.props.getPageScale(),
                renderRectConfig,
            });
        });
    }
}
